import React, { useEffect } from "react"
import { SEGMENT_ANONYMOUS_ID_COOKIE } from "../../constants/cookies"

const ExternalScripts = () => {
  const getCookieByName = (name) => {
    let match = document.cookie.match(RegExp("(?:^|;\\s*)" + name + "=([^;]*)"))
    return match ? match[1] : null
  }

  const setSegmentCookie = () => {
    if (typeof window !== `undefined`) {
      if (
        typeof window.analytics !== `undefined` &&
        typeof window.analytics.user !== `undefined` &&
        typeof window.analytics.user().anonymousId !== `undefined`
      ) {
        // NT2-30510: gatsby-ssr pre-seeds this cookie; only backfill if missing
        let cname = SEGMENT_ANONYMOUS_ID_COOKIE
        let cvalue = window.analytics.user().anonymousId()
        let exdays = 30
        let d = new Date()
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
        let expires = "expires=" + d.toUTCString()
        if (getCookieByName(cname) === null) {
          document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"
          console.log("segment_anonymous_id set")
        }
      } else {
        // console.log("else")
        setTimeout(() => {
          setSegmentCookie()
        }, 1500)
      }
    }
  }

  useEffect(() => {
    setSegmentCookie()
  }, [])

  return <div id="extscriptcontainer" />
}

export default ExternalScripts
